// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3q9ps","list":"BalanceDue_list__3frZA","listRow":"BalanceDue_listRow__3db4e","total":"BalanceDue_total__3wS42"};